import React, { useContext, useState } from "react";
import { SortingRule } from "react-table";

interface IAdminUserTableContext {
  searchValue?: string;
  setSearchValue: React.Dispatch<React.SetStateAction<string | undefined>>;
  sortBy: SortingRule<any>[];
  setSortBy: React.Dispatch<React.SetStateAction<SortingRule<any>[]>>;
  pageIndex: number;
  setPageIndex: React.Dispatch<React.SetStateAction<number>>;
}

export const AdminUserTableContext = React.createContext<IAdminUserTableContext>({
  searchValue: "",
  setSearchValue: () => null,
  sortBy: [],
  setSortBy: () => null,
  pageIndex: 0,
  setPageIndex: () => null,
});

interface Props {
  children: React.ReactNode;
}

const AdminUserTableProvider = ({ children }: Props) => {
  const [searchValue, setSearchValue] = useState<string>();
  const [sortBy, setSortBy] = useState<SortingRule<any>[]>([{ id: "lastName", desc: false }]);
  const [pageIndex, setPageIndex] = useState(0);

  return (
    <AdminUserTableContext.Provider
      value={{
        searchValue,
        setSearchValue,
        sortBy,
        setSortBy,
        pageIndex,
        setPageIndex,
      }}
    >
      {children}
    </AdminUserTableContext.Provider>
  );
};

export default AdminUserTableProvider;

export const useAdminUserTable = () => {
  const helpers = useContext(AdminUserTableContext);

  return helpers;
};

export const useAdminUserTableSearch = () => {
  const { searchValue, setSearchValue } = useContext(AdminUserTableContext);

  return { searchValue, setSearchValue };
};
